var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkFlatline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    "data-imageid": "network-flatline",
    imageName: "Network",
    className: "illustrations_image",
    style: {
      width: 188
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_154_network_flatline",
    "data-name": "#154_network_flatline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.75,252.48A102.48,102.48,0,1,1,303.23,150,102.59,102.59,0,0,1,200.75,252.48Zm0-199A96.48,96.48,0,1,0,297.23,150,96.59,96.59,0,0,0,200.75,53.52Z",
    fill: "#ff3700",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.61,126.06h62.28a4.66,4.66,0,0,1,4.66,4.66v38a0,0,0,0,1,0,0h-71.6a0,0,0,0,1,0,0v-38A4.66,4.66,0,0,1,262.61,126.06Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.55,169.22H258a.46.46,0,0,1-.46-.46v-38a5.12,5.12,0,0,1,5.12-5.12h62.28a5.11,5.11,0,0,1,5.11,5.12v38A.46.46,0,0,1,329.55,169.22Zm-71.15-.92h70.69V130.73a4.21,4.21,0,0,0-4.2-4.21H262.61a4.22,4.22,0,0,0-4.21,4.21Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.07,169.26H262.42a.5.5,0,0,1-.5-.5V129.89a.5.5,0,0,1,.5-.5h62.65a.5.5,0,0,1,.5.5v38.87A.5.5,0,0,1,325.07,169.26Zm-62.15-1h61.65V130.39H262.92Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.52,169.28H252a.52.52,0,0,1-.52-.52.52.52,0,0,1,.52-.52h83.54a.51.51,0,0,1,.51.52A.52.52,0,0,1,335.52,169.28Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.5,168.76H337a0,0,0,0,1,0,0v0a5.18,5.18,0,0,1-5.18,5.18H255.68a5.18,5.18,0,0,1-5.18-5.18v0a0,0,0,0,1,0,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.82,174.39H255.68a5.64,5.64,0,0,1-5.64-5.63.47.47,0,0,1,.46-.46H337a.46.46,0,0,1,.46.46A5.64,5.64,0,0,1,331.82,174.39ZM251,169.22a4.73,4.73,0,0,0,4.7,4.26h76.14a4.72,4.72,0,0,0,4.69-4.26Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.73,
    y: 168.76,
    width: 14.03,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.78,
    y: 210.35,
    width: 57.94,
    height: 54.19,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.72,265.06H171.78a.52.52,0,0,1-.52-.52V210.35a.52.52,0,0,1,.52-.52h57.94a.51.51,0,0,1,.51.52v54.19A.52.52,0,0,1,229.72,265.06Zm-57.43-1H229.2V210.86H172.29Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.18,
    y: 253.96,
    width: 67.13,
    height: 19.02,
    rx: 4.62,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.7,273.5H171.8a5.13,5.13,0,0,1-5.13-5.13v-9.79a5.13,5.13,0,0,1,5.13-5.13h57.9a5.13,5.13,0,0,1,5.13,5.13v9.79A5.13,5.13,0,0,1,229.7,273.5Zm-57.9-19a4.11,4.11,0,0,0-4.1,4.1v9.79a4.11,4.11,0,0,0,4.1,4.1h57.9a4.11,4.11,0,0,0,4.1-4.1v-9.79a4.11,4.11,0,0,0-4.1-4.1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.18,
    y: 230.78,
    width: 67.13,
    height: 19.02,
    rx: 4.62,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.7,250.32H171.8a5.13,5.13,0,0,1-5.13-5.13V235.4a5.13,5.13,0,0,1,5.13-5.13h57.9a5.13,5.13,0,0,1,5.13,5.13v9.79A5.13,5.13,0,0,1,229.7,250.32Zm-57.9-19a4.11,4.11,0,0,0-4.1,4.1v9.79a4.11,4.11,0,0,0,4.1,4.1h57.9a4.11,4.11,0,0,0,4.1-4.1V235.4a4.11,4.11,0,0,0-4.1-4.1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.18,
    y: 207.6,
    width: 67.13,
    height: 19.02,
    rx: 4.62,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.7,227.14H171.8a5.13,5.13,0,0,1-5.13-5.13v-9.79a5.14,5.14,0,0,1,5.13-5.14h57.9a5.14,5.14,0,0,1,5.13,5.14V222A5.13,5.13,0,0,1,229.7,227.14Zm-57.9-19a4.11,4.11,0,0,0-4.1,4.1V222a4.11,4.11,0,0,0,4.1,4.1h57.9a4.11,4.11,0,0,0,4.1-4.1v-9.79a4.11,4.11,0,0,0-4.1-4.1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.51,
    cy: 214.24,
    r: 1.27,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51,216a1.77,1.77,0,1,1,1.77-1.77A1.77,1.77,0,0,1,175.51,216Zm0-2.54a.77.77,0,1,0,0,1.54.77.77,0,1,0,0-1.54Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.87,
    cy: 214.24,
    r: 1.27,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.87,216a1.77,1.77,0,1,1,1.77-1.77A1.78,1.78,0,0,1,180.87,216Zm0-2.54a.77.77,0,1,0,.77.77A.77.77,0,0,0,180.87,213.47Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.24,
    cy: 214.24,
    r: 1.27,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.24,216a1.77,1.77,0,1,1,1.77-1.77A1.77,1.77,0,0,1,186.24,216Zm0-2.54a.77.77,0,1,0,0,1.54.77.77,0,1,0,0-1.54Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.22,
    y: 106.56,
    width: 72.49,
    height: 51.35,
    rx: 2.56,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.15,158.41H72.78a3.06,3.06,0,0,1-3.06-3.06V109.12a3.06,3.06,0,0,1,3.06-3.06h67.37a3.06,3.06,0,0,1,3.06,3.06v46.23A3.06,3.06,0,0,1,140.15,158.41ZM72.78,107.06a2.06,2.06,0,0,0-2.06,2.06v46.23a2.07,2.07,0,0,0,2.06,2.06h67.37a2.06,2.06,0,0,0,2.06-2.06V109.12a2.06,2.06,0,0,0-2.06-2.06Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,154.83H72.9a.5.5,0,0,1-.5-.5V110.14a.5.5,0,0,1,.5-.5H140a.5.5,0,0,1,.5.5v44.19A.5.5,0,0,1,140,154.83Zm-66.63-1h66.13V110.64H73.4Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.25 165.34 95.68 165.34 98.12 157.91 114.81 157.91 117.25 165.34",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.25,165.86H95.68a.51.51,0,0,1-.42-.22.53.53,0,0,1-.07-.46l2.44-7.43a.53.53,0,0,1,.49-.36h16.69a.51.51,0,0,1,.49.36l2.44,7.43a.5.5,0,0,1-.07.46A.51.51,0,0,1,117.25,165.86Zm-20.86-1h20.15l-2.1-6.41h-16Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.85,
    y: 165.34,
    width: 27.23,
    height: 2.09,
    rx: 1.05,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,168H93.9a1.56,1.56,0,0,1,0-3.12H119a1.56,1.56,0,1,1,0,3.12ZM93.9,165.86a.53.53,0,1,0,0,1.06H119a.53.53,0,1,0,0-1.06Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.33,163.37c.35-.18,19-3.6,19-3.6l-.61-1.86H98Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3,163.89a.49.49,0,0,1-.32-.12.51.51,0,0,1-.13-.55l1.72-5.46a.49.49,0,0,1,.47-.35h16.7a.49.49,0,0,1,.47.34l.62,1.87a.49.49,0,0,1,0,.41.53.53,0,0,1-.34.24c-7.28,1.33-18.34,3.38-18.93,3.57A.54.54,0,0,1,96.3,163.89Zm2.11-5.48-1.35,4.29c2.73-.57,10.66-2,17.64-3.31l-.32-1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.69,175.82c0,2.91-4.14,2.85-9.25,2.85s-9.26.06-9.26-2.85,4.14-7.68,9.26-7.68S164.69,172.91,164.69,175.82Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,179.17h-.86a33.1,33.1,0,0,1-6.46-.36c-.74-.17-3-.66-3-3,0-3.23,4.37-8.18,9.76-8.18s9.75,5,9.75,8.18c0,2.33-2.26,2.82-3,3A31.78,31.78,0,0,1,156,179.17Zm-.57-1h.28a32.86,32.86,0,0,0,6.25-.34c2-.43,2.22-1.26,2.22-2,0-2.77-4-7.18-8.75-7.18s-8.76,4.41-8.76,7.18c0,.75.26,1.58,2.23,2a32.7,32.7,0,0,0,6.24.34Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.44,173.91a.5.5,0,0,1-.5-.5v-5.27a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v5.27A.5.5,0,0,1,155.44,173.91Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.01,
    y: 174.19,
    width: 74.92,
    height: 3.52,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.93,178.21H63a.5.5,0,0,1-.5-.5v-3.52a.5.5,0,0,1,.5-.5h74.92a.5.5,0,0,1,.5.5v3.52A.5.5,0,0,1,137.93,178.21Zm-74.42-1h73.92v-2.52H63.51Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9,
    y: 172.48,
    width: 67.75,
    height: 1.7,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.65,174.69H66.9a.5.5,0,0,1-.5-.5v-1.71a.5.5,0,0,1,.5-.5h67.75a.5.5,0,0,1,.5.5v1.71A.5.5,0,0,1,134.65,174.69Zm-67.25-1h66.75V173H67.4Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.33,
    y: 22.88,
    width: 28.83,
    height: 57.46,
    rx: 1.84,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.32,80.84H188.17a2.34,2.34,0,0,1-2.34-2.34V24.72a2.34,2.34,0,0,1,2.34-2.34h25.15a2.34,2.34,0,0,1,2.34,2.34V78.5A2.34,2.34,0,0,1,213.32,80.84ZM188.17,23.38a1.34,1.34,0,0,0-1.34,1.34V78.5a1.34,1.34,0,0,0,1.34,1.34h25.15a1.34,1.34,0,0,0,1.34-1.34V24.72a1.34,1.34,0,0,0-1.34-1.34Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.65,72.8h-25.8a.5.5,0,0,1-.5-.5V28.08a.5.5,0,0,1,.5-.5h25.8a.5.5,0,0,1,.5.5V72.3A.5.5,0,0,1,213.65,72.8Zm-25.3-1h24.8V28.58h-24.8Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.16,
    y: 74.45,
    width: 7.17,
    height: 4.14,
    rx: 1.13,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.2,79.08h-4.91a1.63,1.63,0,0,1-1.63-1.62V75.58A1.63,1.63,0,0,1,198.29,74h4.91a1.63,1.63,0,0,1,1.63,1.63v1.88A1.63,1.63,0,0,1,203.2,79.08ZM198.29,75a.63.63,0,0,0-.63.63v1.88a.63.63,0,0,0,.63.62h4.91a.63.63,0,0,0,.63-.62V75.58a.63.63,0,0,0-.63-.63Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.35,25.87H196a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h7.34a.5.5,0,0,1,.5.5A.5.5,0,0,1,203.35,25.87Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.37,25.87h-1a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5A.51.51,0,0,1,205.37,25.87Z",
    fill: "#e6e7e8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkFlatline);
export default __webpack_public_path__ + "static/media/network-flatline.b6a3eda6d7fa3eaeb8ba5ecbb3bcec43.svg";
export { ForwardRef as ReactComponent };